import { GlobalResponseObject } from "../../global-response-object";
import { SubCategoryWiseActRevenue } from "./subCategoryWiseActRevenue-details";


export class SubCategoryWiseActRevenueResponse extends GlobalResponseObject{
data?:SubCategoryWiseActRevenue[];
constructor(status: boolean, intlCode: number, internalMessage: string, data?:SubCategoryWiseActRevenue[]){
    super(status,intlCode,internalMessage)
    this.data = data;
}
}